// ref: https://github.com/jusbrasil/finder/blob/e54b649114e41dea78765c4014f746dda199b940/src/utils/haystack-filters/enums/state-filters.json
export const stateFilters = [
  { label: 'Acre', value: 'ac' },
  { label: 'Alagoas', value: 'al' },
  { label: 'Amapá', value: 'ap' },
  { label: 'Amazonas', value: 'am' },
  { label: 'Bahia', value: 'ba' },
  { label: 'Ceará', value: 'ce' },
  { label: 'Distrito Federal', value: 'df' },
  { label: 'Espírito Santo', value: 'es' },
  { label: 'Goiás', value: 'go' },
  { label: 'Maranhão', value: 'ma' },
  { label: 'Mato Grosso', value: 'mt' },
  { label: 'Mato Grosso do Sul', value: 'ms' },
  { label: 'Minas Gerais', value: 'mg' },
  { label: 'Pará', value: 'pa' },
  { label: 'Paraíba', value: 'pb' },
  { label: 'Paraná', value: 'pr' },
  { label: 'Pernambuco', value: 'pe' },
  { label: 'Piauí', value: 'pi' },
  { label: 'Rio de Janeiro', value: 'rj' },
  { label: 'Rio Grande do Norte', value: 'rn' },
  { label: 'Rio Grande do Sul', value: 'rs' },
  { label: 'Rondônia', value: 'ro' },
  { label: 'Roraima', value: 'rr' },
  { label: 'Santa Catarina', value: 'sc' },
  { label: 'São Paulo', value: 'sp' },
  { label: 'Sergipe', value: 'se' },
  { label: 'Tocantins', value: 'to' },
]
